module.exports = __webpack_public_path__ + "static/media/wells-tipper.64bc1135.svg";